import { Link, useLocation } from 'react-router-dom'
import { LogOut, Menu, ExternalLink } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import { topNavItems, getActiveCategory } from '../utils/navigation'
import './Header.css'

export default function Header({ onMenuToggle, sidebarCollapsed }) {
  const { user, logout } = useAuth()
  const location = useLocation()
  const activeCategory = getActiveCategory(location.pathname)

  return (
    <header className="app-header">
      <div className="header-left">
        <button 
          className="menu-toggle" 
          onClick={onMenuToggle}
          title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <Menu size={20} />
        </button>
        <Link to="/" className="logo">
          <span className="logo-text">TBTV</span>
          <span className="logo-vader">VADER</span>
        </Link>
      </div>

      <nav className="top-nav">
        {topNavItems.map(item => {
          const Icon = item.icon
          const isActive = activeCategory === item.id
          
          // External link - opens in new tab
          if (item.external) {
            return (
              <a
                key={item.id}
                href={item.external}
                target="_blank"
                rel="noopener noreferrer"
                className="top-nav-item"
              >
                <Icon size={18} />
                <span>{item.label}</span>
                <ExternalLink size={12} className="external-icon" />
              </a>
            )
          }
          
          // Internal link
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`top-nav-item ${isActive ? 'active' : ''}`}
            >
              <Icon size={18} />
              <span>{item.label}</span>
            </Link>
          )
        })}
      </nav>

      <div className="header-right">
        {user && (
          <div className="user-menu">
            <span className="user-email">{user.email}</span>
            <button onClick={logout} className="logout-btn" title="Logout">
              <LogOut size={18} />
            </button>
          </div>
        )}
      </div>
    </header>
  )
}